
import "../Challenges.css"
import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from '../../../../configs/AppConfig';

const Points = () => {

      const [data , setData] = useState([]);      
        const token = localStorage.getItem('token');
        const decoded = jwtDecode(token);
        const id = decoded.id;
      
     useEffect(() => {
     api.get(`${API_BASE_URL}student/points/${id}`)
      .then((response) => {  
      setData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [id]);

  return (
    <div class="loyalty-card">
    <h4>Points Balance</h4>
    <div class="points-section">
      <div class="circle">
        🏆
      </div>
      <div class="points-text">
        <h1>{data} pts</h1>
        <p>Collect points by end your challanges</p>
      </div>
    </div>
    </div>
  );
};

export default Points;
